export enum Feature {
  Certificates,
  SpecialCertificate,
  LevelSystem,
  RecomendationCarrousel,
  Cart,
  Whishlist,
  MyOrders,
}
